import WelcomeOrgTeams from '@/screens/WelcomeOrgTeams';

export default function PrivateWelcomeOrgTeamsRoute() {
  return <WelcomeOrgTeams />;
}
